// A case-insensitive pattern for a search field. The query is a regular
// expression; one that doesn't parse (a lone "(" while typing) matches as
// plain text instead.
export function searchPattern(query) {
  try {
    return new RegExp(query, "i");
  } catch {
    return new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i");
  }
}
